import React from 'react';

const MapaInteractivo = ({ width = "100%", height = "400px" }) => {
  return (
    <div style={{ width, height, borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6843.7214990265875!2d-99.10798284717497!3d19.660793625590898!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f50018495dd3%3A0x681a17c5f8b6a376!2sFelipe%20vinicio%20Berriozabal%20No.%2029!5e0!3m2!1ses!2smx!4v1765091394928!5m2!1ses!2smx"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Ubicación TecnoVigilancia 360 - Felipe Vinicio Berriozábal No. 29, Coacalco, Estado de México"
      ></iframe>
    </div>
  );
};

export default MapaInteractivo;
